import { Input } from "antd";

import "./styles.scss";

const InputComponent = ({
  width,
  placeholder,
  type,
  onEnter,
  error,
  des,
  value,
  name,
  onChange,
  disabled,
  suffix,
  prefixOut,
  onlyInteger,
  className,
  title,
  subtitle,
  allow,
  defaultValue,
  readOnly,
  ...props
}) => {
  const onKeyUp = (e) => {
    if (e.code === "Enter" && onEnter) {
      onEnter();
    }
  };

  const onKeyDown = (e) => {
    if (type === "numberString") {
      if (
        !(
          (e.keyCode >= 96 && e.keyCode <= 105) ||
          (e.keyCode >= 48 && e.keyCode <= 57)
        ) &&
        !e.ctrlKey &&
        e.code !== "Backspace"
      ) {
        e.preventDefault();
      }
    }
  };

  return (
    <div
      className="input-container"
      style={{ width: des ? width + 78 : width ? width : "100%" }}
    >
      {title && <div className="input-title">{title}</div>}
      {subtitle && <div className="input-subtitle">{subtitle}</div>}
      <div className="input-and-description">
        {prefixOut}
        <Input
          className={error ? `${className} error-text` : className}
          placeholder={placeholder}
          type={type}
          width={width || "100%"}
          onKeyUp={onKeyUp}
          onKeyDown={onKeyDown}
          value={value}
          name={name}
          onChange={onChange}
          disabled={disabled}
          suffix={suffix}
          defaultValue={defaultValue}
          readOnly={readOnly}
          {...props}
        />
        {des && <div className="des-text">({des})</div>}
      </div>
      {error ? <span className="input-error-message">{error}</span> : null}
    </div>
  );
};
export default InputComponent;
